import { render, staticRenderFns } from "./CenterViewShippingMail_Ap.vue?vue&type=template&id=fd6b24d4&scoped=true"
import script from "./CenterViewShippingMail_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewShippingMail_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewShippingMail_Ap.vue?vue&type=style&index=0&id=fd6b24d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6b24d4",
  null
  
)

export default component.exports